import type { DocumentMarkupPoint, DocumentMarkupStroke, DocumentMarkupTool } from '../../types';

export interface MarkupCommitPayload {
  pageNumber: number;
  tool: Exclude<DocumentMarkupTool, 'eraser'>;
  color: string;
  strokeWidth: number;
  points: DocumentMarkupPoint[];
  text?: string;
  fill?: string;
  textColor?: string;
  stampId?: string;
  stampScale?: number;
  stampRotation?: number;
}

export type MarkupStrokePatch = Partial<
  Pick<DocumentMarkupStroke, 'text' | 'points' | 'stampRotation' | 'stampScale'>
>;

export const MARKUP_HISTORY_LIMIT = 80;

export type MarkupHistoryOp =
  | { type: 'add'; id: string; payload: MarkupCommitPayload }
  | { type: 'remove'; id: string; payload: MarkupCommitPayload }
  | { type: 'update'; id: string; before: MarkupStrokePatch; after: MarkupStrokePatch };

export function strokeToCommitPayload(stroke: DocumentMarkupStroke): MarkupCommitPayload | null {
  if (stroke.tool === 'eraser' || stroke.points.length === 0) return null;
  return {
    pageNumber: stroke.pageNumber,
    tool: stroke.tool,
    color: stroke.color,
    strokeWidth: stroke.strokeWidth,
    points: stroke.points,
    text: stroke.text,
    fill: stroke.fill,
    textColor: stroke.textColor,
    stampId: stroke.stampId,
    stampScale: stroke.stampScale,
    stampRotation: stroke.stampRotation,
  };
}

export function remapHistoryIds(ops: MarkupHistoryOp[], from: string, to: string): void {
  if (!from || from === to) return;
  for (const op of ops) {
    if (op.id === from) op.id = to;
  }
}

export function pushMarkupHistory(stack: MarkupHistoryOp[], op: MarkupHistoryOp, limit = MARKUP_HISTORY_LIMIT): void {
  stack.push(op);
  if (stack.length > limit) stack.shift();
}
